import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement, isValidElement, useId } from 'react';
import { cx } from '../cx';
/**
 * 表单容器。静态站没有可接收原生 POST 的服务端,因此 `Form` 包装 `onSubmit`:
 * 一律先 `preventDefault()` 再调用传入的 handler,避免整页跳转;需要原生表单
 * 行为时请直接使用 `<form className="wv-form">`。
 */
export function Form({ error, className, children, onSubmit, ref, ...rest }) {
    return (_jsxs("form", { ...rest, ref: ref, className: cx('wv-form', className), onSubmit: (event) => {
            event.preventDefault();
            onSubmit?.(event);
        }, children: [error != null && error !== '' && (_jsx("div", { className: "wv-form__error", role: "alert", children: error })), children] }));
}
/**
 * 字段容器:label + 控件 + hint/error 的布局与可访问性接线。
 * 子控件未提供 `id` 时自动生成并同步到 `<label htmlFor>`;hint/error 通过
 * `aria-describedby` 关联(保留控件已有的 aria-describedby)。
 */
export function FormField({ label, children, error, hint, required = false, className }) {
    const autoId = useId();
    const childProps = isValidElement(children)
        ? children.props
        : {};
    const controlId = childProps.id ?? autoId;
    const hintId = `${controlId}-hint`;
    const errorId = `${controlId}-error`;
    const describedBy = [childProps['aria-describedby'], hint ? hintId : null, error ? errorId : null]
        .filter(Boolean)
        .join(' ') || undefined;
    const control = isValidElement(children)
        ? cloneElement(children, {
            id: controlId,
            'aria-required': required || undefined,
            'aria-invalid': error ? true : childProps['aria-invalid'],
            'aria-describedby': describedBy,
        })
        : children;
    return (_jsxs("div", { className: cx('wv-field', className), children: [_jsxs("label", { className: "wv-field__label", htmlFor: controlId, children: [label, required && (_jsx("span", { className: "wv-field__required", "aria-hidden": "true", children: "*" }))] }), control, hint != null && hint !== '' && (_jsx("p", { className: "wv-field__hint", id: hintId, children: hint })), error != null && error !== '' && (_jsx("p", { className: "wv-field__error", id: errorId, children: error }))] }));
}
